import { VideoProps } from 'features/car/types'
import React, { FC, useCallback, useMemo, useState } from 'react'
import { useCarDetailsCardConfig } from 'stages/car-details'
import styled from 'styled-components'
import { Button } from 'ui/button'
import { Props as ImageProps } from 'ui/image'
import { PreviewSlider } from 'ui/preview-slider/PreviewSlider'

export type PreviewProps = {
  activeSlide: number
  onSlideChange: (value: number | null) => void
  setSlide?: (index: number) => void
  slickSliderVideosRef?: any
}

export type ImagesPreviewProps = PreviewProps & { images: ImageProps[] }

export const ImagesPreview: FC<ImagesPreviewProps> = ({ activeSlide, onSlideChange, images }) => {
  const [isSwipingDisabled, setIsSwipingDisabled] = useState(false)

  const exitPreview = useCallback(() => onSlideChange(null), [onSlideChange])

  return (
    <PreviewSlider
      activeSlide={activeSlide}
      onExit={exitPreview}
      onActiveSlideChange={onSlideChange}
      isSwipingDisabled={isSwipingDisabled}
      images={images}
    />
  )
}

export type VideosPreviewProps = PreviewProps & {
  videos: VideoProps[]
}

export const VideosPreview: FC<VideosPreviewProps> = ({
  activeSlide,
  videos,
  onSlideChange,
  setSlide,
  slickSliderVideosRef
}) => {
  const { i18n } = useCarDetailsCardConfig()
  const exitPreview = useCallback(() => onSlideChange(null), [onSlideChange])

  const VideoButtons = useMemo(() => {
    if (videos?.length === 1) return
    return (
      <>
        {videos &&
          videos.map((video, index) => {
            let buttonText: string
            if (video.view === 'interior') {
              buttonText = i18n.interior
            } else if (video.view === 'exterior') {
              buttonText = i18n.exterior
            } else {
              buttonText = i18n.video
            }

            return (
              <VideoButtonWrapper key={index}>
                <Button key={index} onClick={() => setSlide && setSlide(index)} size="small">
                  {buttonText}
                </Button>
              </VideoButtonWrapper>
            )
          })}
      </>
    )
  }, [onSlideChange, videos, setSlide])

  return (
    <PreviewSlider
      onExit={exitPreview}
      onActiveSlideChange={onSlideChange}
      additionalContent={VideoButtons}
      activeSlide={activeSlide}
      videos={videos}
      slickSliderVideosRef={slickSliderVideosRef}
    />
  )
}

const VideoButtonWrapper = styled.div`
  margin-right: ${({ theme }) => theme.spacing[3]};
`
